import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { BaseConfigSettings } from '../fields';
import { excludedOperators } from '../settings';
import { profileFields } from './profile-fields';

export function qualifioLoyaltyMemberClick(
  settings: BaseConfigSettings,
  customKeys?: CustomKeyAttributes[],
): Fields {
  const { t } = settings;
  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: {
        timestamp: {
          label: t('rule.criteria.date'),
          type: 'datetime',
          preferWidgets: ['datetime'],
        },
        buttonId: {
          label: t('rule.criteria.buttonId'),
          type: 'text',
          excludeOperators: excludedOperators,
        },
      },
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, customKeys),
    },
  };
}
